// Runtime environment configuration
// Reads from window._env_ which is populated by env-config.js

declare global {
  interface Window {
    _env_: {
      REACT_APP_API_BASE_URL: string;
      REACT_APP_GOOGLE_CLIENT_ID: string;
      REACT_APP_RUSTORE_LINK: string;
    };
  }
}

// Fallback to process.env for local development without Docker
export const ENV = {
  API_BASE_URL: window._env_?.REACT_APP_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || 'https://api.auroracatch.com/api/',
  GOOGLE_CLIENT_ID: window._env_?.REACT_APP_GOOGLE_CLIENT_ID || process.env.REACT_APP_GOOGLE_CLIENT_ID || '1063560822655-taimddj1ijganft08h858jk4g6l4qcck.apps.googleusercontent.com',
  RUSTORE_LINK: window._env_?.REACT_APP_RUSTORE_LINK || process.env.REACT_APP_RUSTORE_LINK || 'https://www.rustore.ru/catalog/app/com.auroracatch'
};
